import React from 'react';
import { IButtonProps } from '../../../Interfaces/IButtonProps';
import Button from './MapButton';
import { List } from '../Icons/Light';

const FilterButton = (props: IButtonProps) => {
  const { toggled, onClick } = props;
  return (
    <Button toggled={toggled} onClick={onClick}>
      <List width={23} />
    </Button>
  );
};

export default FilterButton;
